import { useEffect, useState } from 'react';
import { GetComponentTypes } from '../../../../_api';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
//component: AppComponent (/Classes/ResponseModels/AppManagementModel.js)
//setIsloading: function(bool), nullable
const ComponentTypeSelect = ({
	component,
	setComponent,
	setIsLoading = null,
}) => {
	//componentTypes : ComponentType[] (defined in /Classes/ResponseModels/AppManagementModel.js)
	const [componentTypes, setComponentTypes] = useState([]);

	useEffect(() => {
		if (setIsLoading) {
			setIsLoading(false);
		}
		GetComponentTypes().then(types => {
			setComponentTypes(types);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		//if component.componentTypeID is null, assign first component type option
		if (
			component.componentType?.id === null ||
			component.componentType?.id === undefined
		) {
			setComponent({
				...component,
				componentTypeID: componentTypes[0]?.id,
				componentType: componentTypes[0],
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [componentTypes]);

	const handleChange = e => {
		setComponent({
			...component,
			componentTypeID: e.target.value,
			componentType: componentTypes.filter(
				type => type.id === e.target.value
			),
		});
	};

	return (
		<div>
			<p>Component Type </p>
			<Select
				labelId='Component_Type_SelectDropdown'
				id='Component_Type_SelectDropdown'
				value={
					component.componentTypeID === undefined
						? -1
						: component.componentTypeID
				}
				label='ApplicationType'
				onChange={e => handleChange(e)}
				name='f_Component_ID'
			>
				{componentTypes?.map(option => {
					return (
						<MenuItem key={option.id} value={option.id}>
							{option.description} ({option.id})
						</MenuItem>
					);
				})}
			</Select>
		</div>
	);
};

export default ComponentTypeSelect;
